import { Erod } from '@cotera/era';
import { useTools } from './use-tools-info';

export type ToolSchema = {
  key: string;
  name: string;
  description: string;
  provider: string;
  inputSchema: Erod.Def<any>;
  /** Per-field input descriptions (dropped from `inputSchema`'s reconstructed type). */
  inputFieldDescriptions: Record<string, string>;
  outputSchema: Erod.Def<any>;
  method: Erod.Method;
};

/**
 * Returns a lookup function to get tool schema information from v2 API data.
 * Reconstructs Erod.Def schemas from the Ty.ExtendedAttributeType returned by the API.
 */
export const useToolSchemaLookup = (): ((
  toolName: string
) => ToolSchema | null) => {
  const tools = useTools();

  return (toolName: string): ToolSchema | null => {
    // Try exact match first, then try with slashes replaced by underscores
    const normalizedName = toolName.replaceAll('_', '/');
    const tool = tools.find(
      (t) => t.key === toolName || t.key === normalizedName
    );

    if (tool === undefined) {
      return null;
    }

    return {
      key: tool.key,
      name: tool.name,
      description: tool.description,
      provider: tool.provider,
      inputSchema: Erod.Schema.bareSchemaFromTy(tool.inputTy),
      inputFieldDescriptions: tool.inputFieldDescriptions ?? {},
      outputSchema: Erod.Schema.bareSchemaFromTy(tool.outputTy),
      method: tool.implementationType === 'builtin' ? 'GET' : 'GET',
    };
  };
};
